module.exports = {"id":"223689","name":"Wout Weghorst","rating":"76","photo":"./data/images/photos/0/223689.png","club":{"name":"AZ","logo":"./data/images/clubs/AZ.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WoutWeghorst0.json
// module id = 4363
// module chunks = 0